import '.bx{position:relative;}.ssr-plugin'
import '.i4{width:64px;}.ssr-plugin'
import '.i5{height:64px;}.ssr-plugin'
import '.c0{flex-shrink:0;}.ssr-plugin'
import '.p{position:absolute;}.ssr-plugin'
import '.i6{bottom:-4px;}.ssr-plugin'
import '.cq{right:-4px;}.ssr-plugin'
import '.cn{border-radius:50%;}.ssr-plugin'
import '.i7{border:2px solid var(--shades-white);}.ssr-plugin'
import '.t{overflow:hidden;}.ssr-plugin'
import '.i8{width:32px;}.ssr-plugin'
import '.i9{height:32px;}.ssr-plugin'
import { styled } from 'inlines'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Image } from '@app/components/core/image/Image'

type ConversationAvatarProps = {
  initiativeImage?: string
  userAvatar?: string
  userName: string
}

export const ConversationAvatar = ({
  initiativeImage,
  userAvatar,
  userName,
}: ConversationAvatarProps) => {
  return (
    <div className="bx i4 i5 c0"
    >
      {initiativeImage ? (
        <Image
          src={initiativeImage}
          resizeWidth={128}
          alt="initiative"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '12px',
          }}
        />
      ) : (
        <Avatar
          size="medium"
          shape="square"
          labelSource={userName}
          variant="yellow"
        />
      )}
      <div className="p i6 cq cn i7 t i8 i9"
      >
        <Avatar
          size="extra-small"
          shape="circle"
          image={userAvatar}
          labelSource={userName}
        />
      </div>
    </div>
  )
}
